var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"form-control",attrs:{"items":_vm.turler,"hide-details":_vm.isHideDetails,"item-text":"name","item-value":"id","label":"Yargı Türü","outlined":"","dense":""},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }